<template>
  <div class="customerList">
    <el-form :inline="true" :model="searchForm" ref="searchForm" :rules="searchRules" v-show="showSearchBox">
      <h1>Customer List</h1>
      <el-form-item prop="searchType">
        <el-select v-model="searchForm.searchType" placeholder="Please Select">
          <el-option label="Name" value="cus_name"></el-option>
          <el-option label="Email Address" value="cus_email"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="searchQuery">
        <el-input v-model="searchForm.searchQuery" class="input-with-select" maxlength="30" @keyup.enter.native="onClickSearch">
          <el-button slot="append" icon="el-icon-search" @click="onClickSearch()" :loading="searching"></el-button>
        </el-input>
      </el-form-item>
      <el-form-item style="float: right;">
        <el-button type="primary" plain @click="onClickAdd">Add Customer</el-button>
      </el-form-item>
    </el-form>

    <el-table v-show="showCustomerData || searching" :data="customerData" empty-text="No Record Found" v-loading="searching"
              :cell-style="{textAlign: 'center'}"
              border style="width: 100%" :header-cell-style="{textAlign: 'center', background: '#E5E7E9'}">
      <el-table-column fixed prop="name" label="Customer Name"></el-table-column>
      <el-table-column prop="email" label="Customer Email"></el-table-column>
      <el-table-column prop="addr" label="Address"></el-table-column>
      <el-table-column prop="tel" label="Tel."></el-table-column>
      <el-table-column prop="desc" label="Description"></el-table-column>

      <el-table-column fixed="right" label="Operation" empty-text="No Record Found" width="200">
        <template slot-scope="scope">
          <el-button-group v-show="showCustomerData">
            <el-button type="primary" plain icon="el-icon-edit" @click="onClickModify(scope.row)"></el-button>
            <el-button type="primary" plain icon="el-icon-delete" @click="onClickDelete(scope.row)"></el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @current-change="handleCurrentChange"
      :current-page=curPage
      layout="total, prev, pager, next, jumper"
      :total=numOfData
      v-show="showCustomerData">
    </el-pagination>
  </div>
</template>

<script>
import {getCustomerList, deleteCustomer, searchCustomer, searchCustomerByPage} from '../api'
import moment from 'moment'
export default {
  name: 'CustomerList',
  data () {
    return {
      searching: false,
      downloading: false,
      customerData: [],
      showCustomerData: false,
      showSearchBox: true,
      numOfData: 0,
      numOfPage: 0,
      curPage: 1,
      searchForm: {
        searchType: '',
        searchQuery: ''
      },
      searchRules: {
        searchQuery: [
          { required: true, message: 'Please Enter the Search Query', trigger: 'blur' }
        ],
        searchType: [
          { required: true, message: 'Please Select a Search Type', trigger: 'blur' }
        ]
      }
    }
  },
  created: function () {
    this.searching = false
    this.showSearchBox = true
    this.showCustomerData = false
  },
  mounted: function () {
    this.getDataList()
  },
  methods: {
    getDataList () {
      let that = this
      that.searching = true
      getCustomerList().then(data => {
        console.log('getCustomerList Succeed')
        console.log(data)

        that.customerData = data.cus_list
        that.numOfData = data.count
        that.numOfPage = data.pagecount
        that.curPage = 1
        that.showCustomerData = true
        that.searching = false
      }).catch(error => {
        if (error) {
          console.log(error.stack)
        }
        that.searching = false
      })
    },
    handleCurrentChange (val) {
      let that = this
      that.searching = true
      searchCustomerByPage(val).then(data => {
        console.log('searchCustomerByPage Succeed')
        console.log(data)

        that.customerData = data.cus_list
        that.numOfData = data.count
        that.numOfPage = data.pagecount
        that.curPage = val
        that.showCustomerData = true
        that.searching = false
      }).catch(error => {
        if (error) {
          console.log(error.stack)
        }
        that.searching = false
      })
    },
    onClickView (row) {
      console.log(row)
    },
    onClickSearch () {
      let that = this
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          that.searching = true
          console.log('onClick Search')
          console.log('search type = ', that.searchForm.searchType)
          console.log('search query = ', that.searchForm.searchQuery)

          searchCustomer(that.searchForm.searchType, encodeURIComponent(that.searchForm.searchQuery)).then(data => {
            console.log('searchCustomer Succeed')
            console.log(data)
            that.searching = false
            that.customerData = data.cus_list
            that.numOfData = data.count
            that.numOfPage = data.pagecount
            that.curPage = 1
            that.showCustomerData = true
            that.showSearchBox = true
          }).catch(error => {
            if (error) {
              console.log(error.stack)
            }
            that.searching = false
          })
        }
      })
    },
    onClickDelete (row) {
      let that = this
      let delJsonData = {}

      this.$confirm('This operation will permanentaly delete this Customer record. Continue?', 'Hints', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        Object.assign(delJsonData, {'cus_id': row.cus_id})
        console.log(delJsonData)
        that.searching = true
        deleteCustomer(delJsonData).then(data => {
          console.log('deleteCustomer Succeed')
          console.log(data)
          that.searching = false
          that.$notify({
            title: 'Success',
            message: 'Customer is deleted Successfully',
            type: 'success'
          })
          that.getDataList()
        }).catch(error => {
          if (error.response) {
            if (error.response.status === 400) {
              that.$notify.error({
                title: 'Error',
                message: 'Customer occupied by one or more licenses, Cannot be deleted.'
              })
            } else if (error) {
              console.log(error.stack)
            }
          }
          that.searching = false
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Operation Canceled'
        })
      })
    },
    onClickModify (row) {
      console.log('Route to ModifyCustomer')
      this.$router.push({name: 'CustomerForm', params: {data: row, action: 'modify'}})
    },
    onClickAdd (row) {
      console.log('Route to AddCustomer')
      this.$router.push({name: 'CustomerForm', params: {data: null, action: 'add'}})
    },
    // Format Timestamps
    dateFormat: function (row, column) {
      let date = row[column.property]
      if (date === -1) {
        return 'No Limit'
      }
      if (date === undefined) {
        return ''
      }
      return moment.utc(date).format('YYYY-MMM-DD HH:mm:ss ZZ', true)
    },
    jsonFormat: function (row, column, cellValue, index) {
      var jsonObj = cellValue
      if (jsonObj === undefined) {
        return ''
      }
      const jsonStr = JSON.stringify(jsonObj)
      return jsonStr
    },
    licTypeFormat: function (row, column) {
      let licType = row[column.property]
      switch (licType) {
        case 0: return 'Web'
        case 1: return 'Local'
        default: return 'Unknown Type'
      }
    }
  }
}
</script>

<style>
.el-select .el-input {
  width: 180px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
</style>

<style>
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.el-table .cell {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// CustomerList.vue?15f45cd3